var map = {
	"./": [
		522
	],
	"./en": [
		1182,
		6
	],
	"./en.js": [
		1182,
		6
	],
	"./id": [
		1183,
		7
	],
	"./id.js": [
		1183,
		7
	],
	"./index": [
		522
	],
	"./index.js": [
		522
	],
	"./ja": [
		1184,
		8
	],
	"./ja.js": [
		1184,
		8
	],
	"./ko": [
		1185,
		9
	],
	"./ko.js": [
		1185,
		9
	],
	"./th": [
		1186,
		10
	],
	"./th.js": [
		1186,
		10
	],
	"./vi": [
		1187,
		11
	],
	"./vi.js": [
		1187,
		11
	],
	"./zh": [
		1188,
		12
	],
	"./zh.js": [
		1188,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1189;
module.exports = webpackAsyncContext;